'use strict';

/**
 * Lazysizes configuration for FirstSpirit content assets.
 *
 * Applied only when FirstSpirit content is present so `window.lazySizesConfig`
 * is not set site-wide (which would trigger Born's lazyload on every page).
 */

/**
 * Sets Born-matching lazysizes defaults on `window.lazySizesConfig`.
 *
 * Must run before the lazysizes module is first evaluated.
 *
 * @returns {void}
 */
export function applyFirstSpiritLazySizesConfig() {
    if (typeof window === 'undefined') {
        return;
    }

    window.lazySizesConfig = window.lazySizesConfig || {};
    window.lazySizesConfig.ricTimeout = 100;
    window.lazySizesConfig.loadHidden = false;
    window.lazySizesConfig.loadMode = 1;
}
